module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#cinema",
      toString: function () {
        return this.url;
      }
    }